import React from 'react';
import List from 'components/list/List';
import { Profile } from 'types/profile';
import ProfileItem from './ProfileItem';

type ProfileListProps = {
  profiles: Profile[];
};

const ProfileList: React.FC<ProfileListProps> = ({ profiles }) => {
  return (
    <List>
      {profiles.map(profile => (
        <ProfileItem profile={profile} key={profile.id} />
      ))}
    </List>
  );
};

export default ProfileList;
